(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["videoheroslider"] && !Shopify.designMode) return;
  try {
    
class HeroCarousel {
  constructor(element) {
    this.carousel = element;
    if (!this.carousel) return;

    this.track = this.carousel.querySelector('.carousel-track');
    this.slides = Array.from(this.track.children);
    this.nextButton = this.carousel.querySelector('.carousel-button.next');
    this.prevButton = this.carousel.querySelector('.carousel-button.prev');
    this.dotsNav = this.carousel.querySelector('.carousel-nav');

    this.slideCount = this.slides.length;
    if (this.slideCount <= 1) {
      if(this.nextButton) this.nextButton.style.display = 'none';
      if(this.prevButton) this.prevButton.style.display = 'none';
      if(this.dotsNav) this.dotsNav.style.display = 'none';
      this.lazyLoadMedia(this.slides[0]); // Load the single slide
      this.playCurrentVideo();
      return;
    };

    this.init();
  }

  init() {
    this.currentIndex = 1;
    this.autoplayInterval = null;
    this.autoplayEnabled = this.carousel.dataset.autoplayEnabled === 'true';
    this.autoplayDelay = parseInt(this.carousel.dataset.autoplayDelay, 10);

    this.cloneSlides();
    this.allSlides = Array.from(this.track.children);
    this.updateSlideWidths();
    this.createDots();
    this.attachEventListeners();
    this.lazyLoadMedia(this.allSlides[this.currentIndex]);
    this.updateDots();
    
    if (this.autoplayEnabled) {
      this.startAutoplay();
    }
    
    // Use IntersectionObserver to play/pause video when in view
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          if (this.autoplayEnabled) this.startAutoplay();
          this.playCurrentVideo();
        } else {
          this.stopAutoplay();
          this.pauseAllVideos();
        }
      });
    }, { threshold: 0.5 });
    
    this.observer.observe(this.carousel);
  }
  
  cloneSlides() {
    const firstClone = this.slides[0].cloneNode(true);
    const lastClone = this.slides[this.slideCount - 1].cloneNode(true);
    firstClone.classList.add('clone');
    lastClone.classList.add('clone');
    this.track.appendChild(firstClone);
    this.track.insertBefore(lastClone, this.slides[0]);
  }

  updateSlideWidths() {
    this.slideWidth = this.slides[0].getBoundingClientRect().width;
    this.track.style.width = `${100 * this.allSlides.length}%`;
    this.allSlides.forEach(slide => slide.style.width = `${100 / this.allSlides.length}%`);
    this.track.style.transform = `translateX(-${this.slideWidth * this.currentIndex}px)`;
  }
  
  lazyLoadMedia(slide) {
    if (!slide || slide.dataset.loaded === 'true') return;

    const images = slide.querySelectorAll('img[data-src]');
    images.forEach(img => {
      img.src = img.dataset.src;
      img.removeAttribute('data-src');
    });

    slide.dataset.loaded = 'true';
  }

  moveToSlide(targetIndex) {
    this.track.style.transition = `transform var(--transition-speed) ease-in-out`;
    this.currentIndex = targetIndex;
    this.track.style.transform = `translateX(-${this.slideWidth * this.currentIndex}px)`;

    this.lazyLoadMedia(this.allSlides[this.currentIndex]);
    this.lazyLoadMedia(this.allSlides[this.currentIndex + 1]);
    this.updateDots();
    this.playCurrentVideo();
  }

  handleTransitionEnd() {
    if (this.allSlides[this.currentIndex].classList.contains('clone')) {
      this.track.style.transition = 'none';
      if (this.currentIndex === 0) {
        this.currentIndex = this.slideCount;
      } else if (this.currentIndex === this.allSlides.length - 1) {
        this.currentIndex = 1;
      }
      this.track.style.transform = `translateX(-${this.slideWidth * this.currentIndex}px)`;
    }
  }

  createDots() {
    if (!this.dotsNav) return;
    this.dotsNav.innerHTML = '';
    for (let i = 0; i < this.slideCount; i++) {
      const button = document.createElement('button');
      button.classList.add('carousel-indicator');
      button.dataset.index = i;
      button.setAttribute('aria-label', `Go to slide ${i + 1}`);
      this.dotsNav.appendChild(button);
    }
    this.dots = Array.from(this.dotsNav.children);
    this.dots[0].classList.add('current-slide');
  }

  updateDots() {
    if (!this.dots) return;
    const realIndex = (this.currentIndex - 1 + this.slideCount) % this.slideCount;
    this.dots.forEach((dot, index) => {
      dot.classList.toggle('current-slide', index === realIndex);
    });
  }

  startAutoplay() {
    this.stopAutoplay();
    this.autoplayInterval = setInterval(() => {
      this.moveToSlide(this.currentIndex + 1);
    }, this.autoplayDelay);
  }
  
  stopAutoplay() {
    clearInterval(this.autoplayInterval);
  }

  resetAutoplay() {
    if (this.autoplayEnabled) {
      this.stopAutoplay();
      this.startAutoplay();
    }
  }

  pauseAllVideos() {
      this.carousel.querySelectorAll('video').forEach(video => video.pause());
  }

  playCurrentVideo() {
    this.pauseAllVideos();
    const currentSlide = this.allSlides[this.currentIndex];
    const video = currentSlide.querySelector('video');
    if (video) {
        video.play().catch(error => {
            // Autoplay was prevented, which is common. It will play when the user interacts.
        });
    }
  }

  attachEventListeners() {
    if(this.nextButton) this.nextButton.addEventListener('click', () => {
      this.moveToSlide(this.currentIndex + 1);
      this.resetAutoplay();
    });
    
    if(this.prevButton) this.prevButton.addEventListener('click', () => {
      this.moveToSlide(this.currentIndex - 1);
      this.resetAutoplay();
    });

    this.track.addEventListener('transitionend', this.handleTransitionEnd.bind(this));

    if(this.dotsNav) this.dotsNav.addEventListener('click', (e) => {
      const targetDot = e.target.closest('button');
      if (!targetDot) return;
      this.moveToSlide(parseInt(targetDot.dataset.index, 10) + 1);
      this.resetAutoplay();
    });

    window.addEventListener('resize', this.updateSlideWidths.bind(this));
  }
}

// Initialize all carousels on the page
document.querySelectorAll('.hero-carousel').forEach(carouselElement => {
  new HeroCarousel(carouselElement);
});

// Re-initialize when the theme editor updates the section
document.addEventListener('shopify:section:load', function(event) {
  const section = event.target.querySelector('.hero-carousel');
  if (section) {
    new HeroCarousel(section);
  }
});

  } catch(e) { console.error(e); }
})();
})();
